<script setup>
// import DpExpand from "./DpExpand";
import {computed} from 'vue';

const props = defineProps({
  label: { type: String },
  for: { type: String },
  hasMessage: {type: String},
  messages: {type: Array}
});

const classes = computed(() => {
  let classes = [];
  if (props.hasMessage !== undefined) {
    classes.push(`has-message__${props.hasMessage}`)
  }
  return classes;
})


</script>

<script>
export default {
  name: "DpFormItem"
}
</script>

<template>
  <div class="dp-form-item" :class="classes">
    <label v-if="props.label" :for="props.for">{{ props.label }}</label>
    <div class="messages">
      <div v-for="message in messages">
        <component v-bind:is="message" />
      </div>
    </div>
    <slot></slot>
  </div>
</template>

<style scoped>
</style>